<div class="flex flex-col gap-y-8">
  <div class="flex flex-row pb-2 border-b border-border">
    <h1 class="text-2xl text-dark">Tarifas</h1>
  </div>
  <app-generic-crud [genericCrud]="genericCRUD"></app-generic-crud>
</div>
